export default "__VITE_ASSET__HAexww$j__"